import React from 'react';
import PropTypes from 'prop-types';
import { Grid, withStyles } from '@material-ui/core';
import { ADGMAlert, ADGMImage } from 'aurora-components';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import { keyEmptyCheck } from 'aurora-utils/utils';
import {
  addPMAProperties,
  discardApplication,
  initiatePMAWithoutValidation,
} from 'aurora-composition/modules/pma/actions';
import { useDispatch } from 'react-redux';
import CancelApplicationModal from 'aurora-components/PMACancelApplicationModal/cancelApplicationModal';
import history from '../../utils/history';
import styles from './styles';

function DisplayPMAValidations(props) {
  const { classes, validation, data, propertiesTobeAdded, isCrossValidation, failureCode, initiatePMAData } = props;
  const [isOpen, setIsOpen] = React.useState(false);

  const dispatch = useDispatch();

  const keyEmptyCheckValue = (key, isCombine) => {
    console.log(`${key.toLowerCase()}_content`);
    const title = keyEmptyCheck(`${key.toLowerCase()}_title`);
    const description = keyEmptyCheck(`${key.toLowerCase()}_content`);
    if (isCombine) {
      return (
        <div>
          <strong> {title}</strong> {description}
        </div>
      );
    }
    return (
      <div>
        <li> {title}</li>
        <p>{description}</p>
      </div>
    );
  };
  const showAccordion = () => {
    const accordianArray = [];

    Object.keys(validation?.propertyValidations).forEach(key => {
      const property = data?.properties.find(item => {
        return (item.propertyID || item.plotId) === +key;
      });

      // const accord = (
      //   <Accordion
      //     className={classes.accordionContainer}
      //     classes={{
      //       expanded: classes.expandedAccordion,
      //     }}
      //   >
      //     <AccordionSummary expandIcon={<ExpandMoreIcon />} className={`${classes.accordionTitleHead}`}>
      //       <div className={classes.accordionHeader}>
      //         <div className={classes.accordionHeading}>
      //           <div className={classes.accordianHeadingItem}>
      //             <ADGMImage name='redErrorNew.svg' alt='error' width='40px' height='40px' />
      //           </div>
      //           <div className={classes.accordianHeadingItem}>
      //             <Typography variant='subtitle1'>
      //               <FormattedMessage {...messages.unit_number} />
      //             </Typography>
      //             <Typography variant='body1' className={classes.strongText}>
      //               {property?.unitNumber}
      //             </Typography>
      //           </div>
      //           <div className={classes.accordianHeadingItem}>
      //             <Typography variant='subtitle1'>
      //               <FormattedMessage {...messages.unit_reg_number} />
      //             </Typography>
      //             <Typography variant='body1' className={classes.strongText}>
      //               {property?.unitRegNum || property?.unitRegNumber || property?.unitRegistrationNumber}
      //             </Typography>
      //           </div>
      //           <div className={classes.accordianHeadingItem}>
      //             <Typography variant='subtitle1'>
      //               <FormattedMessage {...messages.building_reg_number} />
      //             </Typography>
      //             <Typography variant='body1' className={classes.strongText}>
      //               {property?.buildingRegNum || property?.buildingRegNumber}
      //             </Typography>
      //           </div>
      //           <div className={classes.accordianHeadingItem}>
      //             <Typography variant='subtitle1'>
      //               <FormattedMessage {...messages.plot_number} />
      //             </Typography>
      //             <Typography variant='body1' className={classes.strongText}>
      //               {property?.plotNumber}
      //             </Typography>
      //           </div>
      //         </div>
      //       </div>
      //     </AccordionSummary>
      //     <AccordionDetails className={classes.accordionDetails}>
      //       <ol type='1' className={classes.accordionDetailsList}>
      //         {validation.propertyValidations[key].map(item => {
      //           return <>{keyEmptyCheckValue(item.failureCode)}</>;
      //         })}
      //       </ol>
      //     </AccordionDetails>
      //   </Accordion>
      // );

      const accord = (
        <Accordion
          className={classes.accordionContainer}
          classes={{
            expanded: classes.expandedAccordion,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className={`${classes.accordionTitleHead}`}>
            <div className={classes.accordionHeader}>
              <Grid container>
                <Grid item xs={3} md={1}>
                  <ADGMImage name='redErrorNew.svg' alt='error' width='40px' height='40px' />
                </Grid>

                <Grid item xs={9} md={11}>
                  <Grid container spacing={1}>
                    <Grid item xs={6} md={3}>
                      <div className={classes.accordianHeadingItem}>
                        <Typography variant='subtitle1'>
                          <FormattedMessage {...messages.unit_number} />
                        </Typography>
                        <Typography variant='body1' className={classes.strongText}>
                          {property?.unitNumber}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <div className={classes.accordianHeadingItem}>
                        <Typography variant='subtitle1'>
                          <FormattedMessage {...messages.unit_reg_number} />
                        </Typography>
                        <Typography variant='body1' className={classes.strongText}>
                          {property?.unitRegNum || property?.unitRegNumber || property?.unitRegistrationNumber}
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xs={6} md={3}>
                      <div className={classes.accordianHeadingItem}>
                        <Typography variant='subtitle1'>
                          <FormattedMessage {...messages.building_reg_number} />
                        </Typography>
                        <Typography variant='body1' className={classes.strongText}>
                          {property?.buildingRegNum || property?.buildingRegNumber}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={6} md={3}>
                      <div className={classes.accordianHeadingItem}>
                        <Typography variant='subtitle1'>
                          <FormattedMessage {...messages.plot_number} />
                        </Typography>
                        <Typography variant='body1' className={classes.strongText}>
                          {property?.plotNumber}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </AccordionSummary>
          <AccordionDetails className={classes.accordionDetails}>
            <ol type='1' className={classes.accordionDetailsList}>
              {validation.propertyValidations[key].map(item => {
                return <>{keyEmptyCheckValue(item.failureCode)}</>;
              })}
            </ol>
          </AccordionDetails>
        </Accordion>
      );
      accordianArray.push(accord);
    });
    return accordianArray;
  };
  const addProperties = () => {
    /* eslint-disable */
    if (failureCode === 'VAL096') {
      dispatch(initiatePMAWithoutValidation(initiatePMAData));
    } else {
      if (propertiesTobeAdded.length === 0) {
        if (data?.isRegistration) history.push(`/app/services/pma-registration/${data?.applicationId}`);
        if (data?.isRenewal) history.push(`/app/services/pma-renewal/${data?.applicationId}`);
        if (data?.isAmendment) history.push(`/app/services/pma-amendment/${data?.applicationId}`);
      } else
        dispatch(
          addPMAProperties({
            applicationId: data?.applicationId,
            properties: propertiesTobeAdded,
            isOverride: false,
            ...(data?.isAmendment && { isAmendment: data?.isAmendment }),
          }),
        );
    }
    /* eslint-enable */
  };
  return (
    <>
      <Grid container spacing={3}>
        <Typography variant='h6' component='h1' className={classes.Title}>
          <FormattedMessage {...messages.the_following_properties_have_pending_items_preventing_you_from_inititating} />
        </Typography>
        <Grid item sm={12} md={9}>
          {showAccordion()}
        </Grid>
        <Grid item sm={12} md={3}>
          {/* <Paper className={classes.paperCardFrame}>
            <div className={classes.titleHead}>
              <Typography variant='body1'> */}

          <ADGMAlert visible noBackground={false} type='error' className={classes.adgmAlert} hideIcon>
            <div className={classes.errorBox}>
              <ADGMImage
                name='redErrorNew.svg'
                alt='error'
                width='40px'
                height='40px'
                className={classes.errorIconCls}
              />
              <span className={classes.errCls}>{keyEmptyCheck('errors')}</span>
            </div>
            <ul className={classes.errorContainer}>
              {validation?.crossValidations?.length > 0
                ? validation?.crossValidations.map(item => {
                    return <li>{keyEmptyCheckValue(item?.failureCode, true)}</li>;
                  })
                : ''}
              {failureCode !== 'VAL096' && (
                <li>
                  <FormattedMessage
                    {...messages?.we_have_removed_blocked_units_for_you}
                    values={{
                      s: isCrossValidation ? 0 : propertiesTobeAdded.length,
                    }}
                  />
                </li>
              )}
              {failureCode === 'VAL096' && (
                <li>
                  <FormattedMessage {...messages?.units_are_no_longer_under_the_same_owner} />
                </li>
              )}
            </ul>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: '10px',
                justifyContent: 'center',
                marginBottom: '5px',
              }}
            >
              {!isCrossValidation && (
                <Button
                  color='primary'
                  variant='contained'
                  onClick={addProperties}
                  className={classes.btnCls}
                  // disabled={propertiesTobeAdded.length === 0}
                >
                  <FormattedMessage {...messages.continue_application} />
                </Button>
              )}
              {isCrossValidation && (
                <Button
                  color='primary'
                  variant='contained'
                  className={classes.btnCls}
                  onClick={() => {
                    if (data?.isRegistration) history.push(`/app/services/pma-registration/${data?.applicationId}`);
                    if (data?.isRenewal) history.push(`/app/services/pma-renewal/${data?.applicationId}`);
                    if (data?.isAmendment) history.push(`/app/services/pma-amendment/${data?.applicationId}`);
                  }}
                >
                  <FormattedMessage {...messages.continue} />
                </Button>
              )}
              <Button
                style={{
                  marginTop: '10px',
                  color: '#D2374F',
                  textTransform: 'none',
                }}
                onClick={() => {
                  if (failureCode === 'VAL096') history.push('/app/services');
                  else dispatch(discardApplication(data?.applicationId));
                }}
              >
                <ADGMImage name='cancel.svg' alt='delete' className={classes.iconCls} />{' '}
                <FormattedMessage {...messages.cancel_application} />
              </Button>
            </div>
          </ADGMAlert>

          {/* </Typography>
            </div> */}

          {/* </Paper> */}
        </Grid>
      </Grid>
      <CancelApplicationModal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        cancelApplication={() => dispatch(discardApplication(data.applicationId))}
      />
    </>
  );
}

DisplayPMAValidations.propTypes = {
  classes: PropTypes.object.isRequired,
  validation: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  propertiesTobeAdded: PropTypes.array.isRequired,
  isCrossValidation: PropTypes.bool.isRequired,
  failureCode: PropTypes.string,
  initiatePMAData: PropTypes.object,
};
DisplayPMAValidations.defaultProps = {
  failureCode: '',
  initiatePMAData: null,
};
export default withStyles(styles)(DisplayPMAValidations);
